/**
 * Shared constants for file uploaders
 */

/**
 * Types of file uploaders - determines which upload handler to use
 * @property {string} VIDEO - Uses fileUpload for video files
 * @property {string} IMAGE - Uses imageUpload with optimization
 * @property {string} FILE - Uses fileUpload for generic files (default)
 */
export const UPLOADER_TYPE = {
  VIDEO: 'video',
  IMAGE: 'image',
  FILE: 'file',
};

/**
 * Error types for consolidated error state in file uploaders
 */
export const ERROR_TYPES = {
  UPLOAD: 'upload',
  FILE_TYPE: 'fileType',
  URL: 'url',
};
